
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.3463 0.28542L6 4.3894L1.65368 0.285517C1.27664 -0.0937714 0.663916 -0.0952254 0.285093 0.282271C-0.093827 0.659815 -0.0951316 1.27334 0.281804 1.65258L5.31498 6.71633C5.69327 7.09576 6.3089 7.09368 6.68594 6.71536L11.7182 1.65249C12.0952 1.2732 12.0938 0.659671 11.7149 0.282175C11.3361 -0.0953217 10.7234 -0.0938683 10.3463 0.28542Z","fill":"#9C9FAA"}})])
          )
        }
      }
    